export const config = {
  title: 'Chitiz Cleaning Services | Residential & Commercial Cleaning in Kenly, NC',
  meta: {
    description:
      'Chitiz Cleaning Services provides top-quality residential and commercial cleaning, including deep cleans, move-in/move-out, and regular maintenance in Kenly, NC and surrounding areas.',
    keywords: [
      'Chitiz Cleaning Services',
      'Kenly NC Cleaning',
      'Residential Cleaning',
      'Commercial Cleaning',
      'Move-in Cleaning',
      'Deep Cleaning',
      'North Carolina Cleaners',
    ],
    author: 'Chitiz Cleaning Services',
    canonicalUrl: 'https://chitizcleaning.com/',
  },
  sections: {
    header: {
      businessName: 'Chitiz Cleaning Services',
    },
    sectionB: {
      heroTitle: 'Chitiz Cleaning Services',
      heroSubtitle: 'Professional Cleaning for Homes & Businesses in Kenly, NC',
      learnAboutText: 'Explore Our Cleaning Solutions',
      phoneNumber: '9197935065',
      phoneLabel: '(919) 793-5065',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1417833187/photo/professional-cleaner-vacuuming-a-carpet.jpg?s=612x612&w=0&k=20&c=5h8NBR190d46Ni4MclqJ7Zf9ZOtf3TM3gPRJaHUdMjk=',
      cardData: [
        {
          title: 'Residential Cleaning',
          description:
            'We keep your home spotless with one-time, weekly, or biweekly cleanings tailored to your needs.',
        },
        {
          title: 'Commercial Cleaning',
          description:
            'Our experienced team ensures your business space remains clean, hygienic, and welcoming.',
        },
        {
          title: 'Move-In / Move-Out',
          description:
            'Thorough deep cleaning services to prepare your property for move-ins or post-move-outs.',
        },
      ],
      description:
        "Chitiz Cleaning Services is your trusted cleaning partner in Kenly, NC. From recurring home cleaning to large-scale office cleaning and deep sanitization, we deliver satisfaction and sparkling spaces every time.",
    },
    sectionC: {
      servicesTitle: 'Our Cleaning Services',
      servicesDescription:
        'Chitiz Cleaning Services offers personalized cleaning solutions for every space—residential, commercial, and beyond.',
      cards: [
        {
          title: 'Residential Cleaning',
          description:
            'Recurring or one-time home cleaning with attention to detail for kitchens, bathrooms, bedrooms, and more.',
          imageSrc: 'https://media.istockphoto.com/id/654153664/photo/cleaning-service-sponges-chemicals-and-mop.jpg?s=612x612&w=0&k=20&c=vHQzKbz7L8oEKEp5oQzfx8rwsOMAV3pHTV_1VPZsREA=',
          imageAlt: 'Home Cleaning',
        },
        {
          title: 'Commercial Cleaning',
          description:
            'We clean offices, retail spaces, and facilities with professionalism, efficiency, and care.',
          imageSrc: 'https://media.istockphoto.com/id/1316473356/photo/an-employee-pulls-a-trolley-for-cleaning-offices-woman-cleaner-is-engaged-in-work.jpg?s=612x612&w=0&k=20&c=6QWgeQ8HQU4TvT4lu9l2hBLiKUVYLcF_6-deEMn-vb8=',
          imageAlt: 'Office Cleaning',
        },
        {
          title: 'Move-In / Move-Out Services',
          description:
            'Top-to-bottom cleaning for rental turnovers, home sales, or new tenants.',
          imageSrc: 'https://media.istockphoto.com/id/915613234/photo/young-woman-cleaning-wooden-floor-in-new-apartment.jpg?s=612x612&w=0&k=20&c=aKI_YY6YOjrvyhJDf6LSHvvTedx8mdsKyStcN5nMOb0=',
          imageAlt: 'Move In/Out Cleaning',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Deep Cleaning',
        'Post-Construction Cleaning',
        'Kitchen & Bathroom Detailing',
        'Dusting & Vacuuming',
        'Trash Removal',
        'Window Cleaning',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://media.istockphoto.com/id/1448485337/photo/living-room-interior-with-sofa-wicker-armchair-cactus-plant-and-coffee-table.jpg?s=612x612&w=0&k=20&c=I67YxAqtNWwLephUblvejWionL0oPdyWzXlL3bSdFkM=',
        alt: 'Chitiz Cleaning Services Team',
      },
      aboutText: [
        "Chitiz Cleaning Services is a locally owned and operated company offering trusted cleaning solutions in Kenly and surrounding North Carolina areas.",
        "We take pride in our attention to detail, eco-friendly products, and flexible scheduling—ensuring client satisfaction every step of the way.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Chitiz Cleaning Logo',
      businessName: 'Chitiz Cleaning Services',
      contact: {
        phone: '9197935065',
        phoneLabel: '(919) 793-5065',
        email: 'Chitizcleaning@gmail.com',
        website: 'https://chitizcleaning.com/',
        address: '26 Montez Ct, Kenly, NC 27542, United States',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        linkedin: null,
        twitter: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '26 Montez Ct, Kenly, NC 27542, United States',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3260.0425572505764!2d-78.123456789!3d35.5967839123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89ac83d12b29ae4b%3A0x55a1000ef4c0401a!2s26%20Montez%20Ct%2C%20Kenly%2C%20NC%2027542%2C%20USA!5e0!3m2!1sen!2sus!4v1712120000000!5m2!1sen!2sus',
    },
  },
};

export default config;
